import React from 'react';

const MedicalOrganizationSchema = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "@id": "https://womenandtheway.com.au/#medical-organization",
    "name": "Women and the Way",
    "alternateName": "WATW",
    "description": "Women's wellness clinic specializing in Chinese medicine and acupuncture for fertility, pregnancy, and women's health in Currimundi, Sunshine Coast.",
    "url": "https://womenandtheway.com.au",
    "logo": {
      "@type": "ImageObject",
          "url": "https://womenandtheway.com.au/watw_logo.webp"
  },
  "image": "https://womenandtheway.com.au/watw_logo.webp",
    "telephone": "+61 415 537 784",
    "email": "womenandtheway@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "700 Nicklin Way",
      "addressLocality": "Currimundi",
      "addressRegion": "QLD",
      "postalCode": "4551",
      "addressCountry": "AU"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": -26.8035,
      "longitude": 153.1320
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Saturday"],
        "opens": "10:00",
        "closes": "17:00"
      }
    ],
    "medicalSpecialty": [
      "Chinese Medicine",
      "Acupuncture",
      "Women's Health",
      "Fertility Support",
      "Pregnancy Care",
      "Postpartum Support"
    ],
    "availableService": [
      {
        "@type": "MedicalProcedure",
        "name": "Acupuncture",
        "description": "Traditional Chinese medicine acupuncture treatments"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Fertility Support",
        "description": "Natural fertility treatments and preconception care"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Pregnancy Care",
        "description": "Prenatal and postnatal acupuncture support"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Women's Health",
        "description": "Comprehensive women's health and wellness support"
      }
    ],
    "areaServed": {
      "@type": "City",
      "name": "Sunshine Coast",
      "addressRegion": "QLD",
      "addressCountry": "AU"
    },
    "serviceArea": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": -26.8035,
        "longitude": 153.1320
      },
      "geoRadius": "50000"
    },
    "sameAs": [
      "https://www.instagram.com/women_and_the_way",
      "https://www.facebook.com/womenandtheway"
    ],
    "hasCredential": [
      "AHPRA Registered",
      "Chinese Medicine Board of Australia",
      "Traditional Chinese Medicine Practitioner"
    ],
    "foundingDate": "2020",
    "founder": {
      "@type": "Person",
      "name": "Women and the Way Team"
    }
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schemaData)}
    </script>
  );
};

export default MedicalOrganizationSchema; 